<template>
	<GenericInput type="number" :min="min ?? 0" :max="max ?? 4294967296" :step="step ?? 1" :value="modelValue" @update:value="updateValue"/>
</template>
<script setup lang="ts">
import {defineEmits, defineProps} from 'vue'
import GenericInput from '@/Components/UI/Inputs/GenericInput.vue'

defineProps<{
	modelValue:number,
	min?:number,
	max?:number,
	step?:number,
}>()

const emit = defineEmits([
	'update:modelValue',
])

function updateValue(newValue: number): void{
	emit('update:modelValue', newValue)
}
</script>
